var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-drawer",
        {
          ref: "addStuDrawer",
          attrs: {
            size: "960px",
            visible: _vm.visible,
            "header-border": false,
            "destroy-on-close": "",
            "before-close": _vm.beforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            closed: _vm.handleClosed,
          },
        },
        [
          _c("yxtbiz-range-selector", {
            ref: "selector",
            attrs: {
              enableGroupCorp: _vm.isGroup,
              functionCode: _vm.isGroup
                ? "group_task_center"
                : "o2o_train_center",
              dataPermissionCode: _vm.isGroup
                ? "task_manage_platform"
                : "FaceToFaceTeaching_chooseLecturer_extent",
              tabs: _vm.tabs,
              limit: _vm.limit,
              "group-limit": 0,
              visibleOrgIds: [],
              model: "array",
              showTab: "",
            },
            on: { change: _vm.handelSelectChange },
            model: {
              value: _vm.newUsers,
              callback: function ($$v) {
                _vm.newUsers = $$v
              },
              expression: "newUsers",
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_utility_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.sureHandle },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }